export { default } from './themedBorderGenerator'
